<template>
    
    <tablecustom 
        @search="searchB" 
        :columns="columns" 
        :rows="filteredItems" 
        :objParams="objParams"
        @open="open"
    />

    <viewStock 
        v-if="showModal"
        @close="showModal = false"
        :obj="objCard"
        :objTradepoints="objTradepoints"
    />

</template>

<script>
import tablecustom from '@/components/globaltable/index';
import viewStock from './view'
import { Dashboard } from '@/API_Dash'

let apiServe = new Dashboard();

export default{
    props: ['objStock', 'companyId', 'objTradepoints'],
    components: {
        tablecustom,
        viewStock
    },
    data(){
        return{
            form: '',
            objCard: '',
            showModal: false,
            objParams: {
                search: ''
            },
            columns: [
                {
                    name: "ID",
                    text: "stockId",
                    align: "left",
                    status: true,
                    copy: true,
                },
                {
                    name: this.$t("Name"),
                    text: "stockTitle",
                    align: "left",
                    status: true,
                    copy: true
                },
            ],
        }
    },
    created(){
        this.getdata()
    },
    methods: {
        getdata(){
            this.form = this.objStock
        },
        open(e){
            apiServe.getStock(this.companyId, e.stockId).then(result => {
                if(result.status == 'done'){
                    this.objCard = result.data;
                    this.showModal = true;
                } else if(result.status == 'error' && result.error[0] == 'empty company url'){
                    this.$toast.error(this.$t('emptyCompanyUrl'));
                } else {
                    this.$toast.error(this.$t('stockNotFound'))
                }
            })
        },
        searchB(e){
            this.objParams.search = e
        },
    },
    computed: {
        filteredItems: function() {
            return this.form
                // по пошуку
                .filter(item => {
                    return this.objParams.search == '' || item.stockTitle.toString().toLowerCase().indexOf(this.objParams.search.toLowerCase()) !== -1;
                })
        },
    }
}
</script>